<template>
  <div id="resume">
    <!--    <h3 class="titles">My Resume</h3>-->
    <!--    <div style="border: 3px solid #CCCCCC; width: 150px"></div>-->

    <ul>
      <!--      <li>-->
      <!--        <h4>Basic Information</h4>-->
      <!--        <p class="p-common">-->
      <!--          Li Xiangyu is a lecturer at the School of Software Engineering, Beijing Jiaotong University.-->
      <!--          Her primary research areas include <b>bioinformatics</b> and <b>machine learning</b>,-->
      <!--          with a deep focus on the theoretical, methodological, and applied aspects of machine learning and-->
      <!--          artificial intelligence analysis of biological and medical big data.-->
      <!--          She has authored 8 papers as the first author or corresponding author in top/mainstream journals and conferences in the field,-->
      <!--          such as <b>Nucleic Acids Research</b>, <b>Briefings In Bioinformatics</b>, and <b>Journal of Genetics and Genomics</b>.-->
      <!--        </p>-->
      <!--        <p class="p-common">-->
      <!--          She has been the principal investigator for one National Natural Science Foundation of China (Youth) project,-->
      <!--          one basic research fund project of central universities, and one industry-funded project. Additionally,-->
      <!--          she has participated as a key member in several National Natural Science Foundation of China (General) projects-->
      <!--          and various industry-funded projects. She serves as a committee member of the Intelligent Health and-->
      <!--          Bioinformatics Professional Committee of the Chinese Association of Automation and-->
      <!--          acts as a reviewer or program committee member for multiple international journals and conferences.-->
      <!--        </p>-->
      <!--      </li>-->
      <li>
        <h4>Education and Work Experience</h4>
        <div style="font-size: 16px">
          <p class="flex_horizon">
            <span class="time_p">Since 2023.12</span>
            <span class="time_content_p">
              <i><b>Associate Professor</b></i>
              <br/>
              School of Software Engineering,Beijing Jiaotong University
            </span>
          </p>
          <p class="flex_horizon">
            <span class="time_p">2023.1-2024.1</span>
            <span class="time_content_p">
              <i><b>Visiting Scholar(CSC scholarship)</b></i>
              <br/>
              Wellcome Trust Sanger institute
            </span>
          </p>
          <p class="flex_horizon">
            <span class="time_p">2019.09-2023.12</span>
            <span class="time_content_p">
              <i><b>Assistant Professor</b></i>
              <br/>
              School of Software Engineering, Beijing Jiaotong University
            </span>
          </p>
          <p class="flex_horizon">
            <span class="time_p">2013.9-2019.07</span>
            <span class="time_content_p">
              <i><b>Ph.D. in Control Science and Engineering (Area: Bioinformatics)</b></i>
              <br/>
              <a href="http://www.au.tsinghua.edu.cn/" target="_blank">Department of Automation </a>, <a
              href="http://www.tsinghua.edu.cn/" target="_blank">Tsinghua University</a>
              <br/>
              <a href="http://www.cssb.tsinghua.edu.cn/zh/" target="_blank">Bioinformatics Division & Center for System and Synthetic Biology</a>
              <span>, </span>
              <a href="https://www.bnrist.tsinghua.edu.cn/" target="_blank">Tsinghua National Laboratory for Information Science & Technology</a>
              <br/>
              <a href="https://www.au.tsinghua.edu.cn/info/1110/1569.htm" target="_blank">Supervisor: Prof. Xuegong Zhang & Prof. Michael Q. Zhang</a>
            </span>
          </p>
          <p class="flex_horizon">
            <span class="time_p">2009.9-2013.7</span>
            <span class="time_content_p">
              <i><b>B.E. in Statistics</b></i>
              <br/>
              School of Mathematics, Jilin University
            </span>
          </p>
        </div>
      </li>
      <li>
        <h4>Research Interest</h4>
        <p style="font-size: 16px">
          Machine Learning, Bioinformatics, Single cell Omics, Spatial transcriptomics
        </p>
      </li>
      <li>
        <h4>Grants (PI)</h4>
        <ul style="font-size: 16px;margin: 0 10%; text-align: left">
          <li>
            <p>
              National Natural Science Foundation of China, Computational methodology of
              integrating single cell RNA-seq data with spatially-resolved transcriptomic data for cell
              heterogeneous interpretation
            </p>
          </li>
          <li>
            <p>
              Fundamental Research Funds for the Central Universities, Representation learning
              for single-cell omics data
            </p>
          </li>
        </ul>
      </li>
      <li>
        <h4>Teaching</h4>
        <ul style="font-size: 16px;margin: 0 10%; text-align: left">
          <li>
            <p>
              Foundation of Artificial Intelligence (Undergraduate), Instructor
            </p>
          </li>
          <li>
            <p>
              Data Science and Knowledge Discovery (Graduate), Instructor
            </p>
          </li>
          <li>
            <p>
              Statistical Methods with Applications (2014, 2015) Teaching assistant, Tsinghua University
            </p>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Resume'
}
</script>

<style scoped>
.titles {
  color: #998D71;
  text-align: left;
  margin: 20px 0 0 0;
  padding: 0;
}

h4 {
  text-align: left;
}

.p-common {
  line-height: 30px;
  text-align: justify;
  text-indent: 2em;
  font-size: 18px;
}

.time_p {
  text-align: right;
  color: #005BAC;
  font-style: italic;
  font-weight: bold;
  width: 30%;
}

.time_content_p {
  width: 60%;
  text-align: left;
}

.flex_horizon {
  display: flex;
  align-items: center;
  justify-content: space-around;
  justify-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components2/Resume.vue